import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "bundle",
  useLayout: true,
  children: [
    {
      id: SectionsKey.BundleBanner,
      order: 1,
      identifier: Identifiers.BundleBanner,
    },
    {
      id: SectionsKey.BundleContent,
      order: 2,
      identifier: Identifiers.BundleContent,
      dataKey: SectionsKey.BundleContent,
    },
    {
      id: SectionsKey.Testimonial,
      order: 3,
      dataKey: SectionsKey.Testimonial,
      identifier: Identifiers.Testimonial,
    },
    {
      id: SectionsKey.BenefitsSection,
      order: 4,
      identifier: Identifiers.BenefitsSection,
    },
  ],
};

export default PageStruct;
